/**
 * Supabase Client Configuration
 * B20251011-Stack-Switch-Phase01: Use proper env variables
 * AD-20251113-SUPABASE-AUTH-VITE: Added runtime env var checks
 *
 * Uses VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY from environment
 */
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL =
  import.meta.env.VITE_SUPABASE_URL || 'https://ifxetmmcscffwlijpdfs.supabase.co';
const SUPABASE_ANON_KEY =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlmeGV0bW1jc2NmZndsaWpwZGZzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg3NDc3NTUsImV4cCI6MjA3NDMyMzc1NX0.2bun5QQD-WoMv9-IPNJKeTjOsv38B4EGHUwHGo5VD9A';

// Runtime checks in development (warn-only, never throw)
if (import.meta.env.DEV) {
  if (!import.meta.env.VITE_SUPABASE_URL) {
    console.warn(
      '[Supabase Client] VITE_SUPABASE_URL is not set. Using fallback URL. Set VITE_SUPABASE_URL in your .env file for development.'
    );
  } else {
    // Mask URL in logs for security (show only domain)
    const urlObj = new URL(import.meta.env.VITE_SUPABASE_URL);
    console.debug(`[Supabase Client] Configured: ${urlObj.hostname}`);
  }
  if (!import.meta.env.VITE_SUPABASE_ANON_KEY) {
    console.warn(
      '[Supabase Client] VITE_SUPABASE_ANON_KEY is not set. Using fallback key. Set VITE_SUPABASE_ANON_KEY in your .env file for development.'
    );
  } else {
    // Mask key in logs (show only first/last 4 chars)
    const key = import.meta.env.VITE_SUPABASE_ANON_KEY;
    const masked = key.length > 8 ? `${key.substring(0, 4)}...${key.substring(key.length - 4)}` : '***';
    console.debug(`[Supabase Client] Key configured: ${masked}`);
  }
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
});
